window.dataLayer = window.dataLayer || [];

function getAttrForCollectionSlider(element){
    return  JSON.parse(element.querySelector('.collectionBlock-image').getAttribute('data-product'))
}

window.onload = function () {
    //events for index page
    if (document.body.classList.contains('template-index')) {
        $('.collectionGrid-row .collectionBlock').on('click', (event) => {
            if (event.target.tagName === 'path') {
            } else {
                googleTagManagerHandler.onProductClick(getAttrForCollectionSlider(event.currentTarget));
            }
        })
    }

    //events for collection page
    else if (document.body.classList.contains('template-collection')) {
        $('.collectionBlock').on('click', (event) => {
            if (event.target.tagName !== 'path' && !event.target.classList.contains('js-productPreviewColor')
            && !event.target.classList.contains('price')) {
                googleTagManagerHandler.onProductClick(getAttrForCollectionSlider(event.currentTarget));
            }
        })
    }


    //events for product page
    else if (document.body.classList.contains('template-product')) {
        // Send event on product view
        const product = JSON.parse(document.getElementById('product-json').innerHTML);
        const dataLayerItem = {
            id: product.id,
            name: product.title,
            price: product.price / 100,
            category: window.settings.collectionTitle
        }
        window.googleTagManagerHandler.onProductView(dataLayerItem)

        // Send event on add to cart
        document.getElementById('AddToCart').addEventListener('click', (e) => {
            window.googleTagManagerHandler.onAddToCart(dataLayerItem)
        })
    }

    //events for cart page
    else if (document.body.classList.contains('template-cart')) {
        const products = Array.from(document.querySelectorAll('.cart-table-row'))
            .filter(item => item.getAttribute('data-product'))
            .map(item => {
                const dataProduct = JSON.parse(item.getAttribute('data-product'));
                return {
                    id: dataProduct.id,
                    name: dataProduct.name,
                    price: dataProduct.price,
                    category: dataProduct.category,
                    quantity: item.querySelector('.inputCounter').value
                }
            })

        window.googleTagManagerHandler.onViewCart(products)
    }

    else if (document.querySelector('#ssw-page')) {
        wishlistPageGrowave()
    }

}


function wishlistPageGrowave() {
    if (!document.querySelector('#ssw-page .ssw-loader')) {
        const favePageLists = document.querySelector('#ssw-fave-page-lists');

        if (favePageLists !== null) {
            const unfaveElements = favePageLists.querySelectorAll('.fave-page-unfave');

            unfaveElements.forEach(function(element) {

                element.addEventListener('click', () => {
                    const product = element.closest('.ssw-fave-item');

                    getProductData(product.dataset.id).then((category) => {
                        if (!category.status) {
                            window.googleTagManagerHandler.onRemoveFromWishlist({
                                currency: 'UZS',
                                id: product.dataset.id,
                                name: product.dataset.title,
                                price: product.dataset.price,
                                category: category
                            })
                        }
                    });
                });
            });
        }
    } else {
        setTimeout(wishlistPageGrowave, 100);
    }
}


async function getProductData(productId) {
    const queryOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Shopify-Storefront-Access-Token": "112b7330c5d8676b9125c6053656b3b7",
        },
        body: JSON.stringify({
        query: `
           query getProduct($id: ID!) {
                product(id: $id) {
                    productType
                }
            }
        `,
            variables: { id: `gid://shopify/Product/${productId}` },
        }),
    };

    let productRes, product;
    let loadRes = { status: "ok" };
    let category = null

    try {
        productRes = await fetch("/api/2021-01/graphql", queryOptions);
        product = await productRes.json();
        category = product.data.product.productType
        return category;
    } catch (e) {
        console.warn("Something went wrong: ", e);
        loadRes = { status: "error" };
    }

    if (loadRes.status === "error") {
        return loadRes;
    }
}